export interface TemplateItemOption {
  name: string;
  description: string;
  type: ItemType;
}

export enum ItemType {
  Text = "text",
  Image = "image",
  Button = "button",
  Html = "html",
  Footer = "footer",
}

export enum ItemAlignment {
  Left = "left",
  Center = "center",
  Right = "right",
}

export interface TemplateItem {
  id: string;
  type: ItemType;
  htmlString: string;
  content: string;
}

export interface TextItem extends TemplateItem {
  text: string;
  variables: { name: string }[];
}

export interface ImageItem extends TemplateItem {
  image_src: string;
  url: string | undefined;
  alignment: ItemAlignment;
  width: number | undefined;
  height: number | undefined;
}

export interface ButtonItem extends TemplateItem {
  text: string;
  url: string;
  alignment: ItemAlignment;
  backgroundColor: string;
  foregroundColor: string;
  fullWidth: boolean;
}

export interface HtmlItem extends TemplateItem {
  content: string;
}

export interface FooterItem extends TemplateItem {
  year: string;
  entityName: string;
  email: string;
  backgroundColor: string;
}

export interface ItemTypeMapper {
  [ItemType.Text]: TextItem;
  [ItemType.Image]: ImageItem;
  [ItemType.Button]: ButtonItem;
  [ItemType.Html]: HtmlItem;
  [ItemType.Footer]: FooterItem;
}
